import './boot/playerLoading.css';
import './boot/lobby-grid.css';
import './boot/account-skel.css';
import './deposit/deposit-error-boundary.css';
import './deposit/deposit-layout.css';
import './turnover/turnover-page.css';
import './referral/referral-page.css';
import './last-winning/last-winning.css';
import './vip/vip-center.css';
import './affiliate/affiliate-commission.css';
import './wallet-negative.css';
import './profile/profile-ux.css';
import './promotions/promo-page.css';
import './profile/personal-info-page.css';
import './history/betting-records.css';
import './transactions/transaction-records.css';
import './alfa9-theme.css';
import './casino-brand.css';
import { captureAgentRefFromLocation } from './agent-referral/capture.js';
import './boot/inactivityLogout.boot.js';

captureAgentRefFromLocation();

import './ninet6-app.js';
